import { render, staticRenderFns } from "./HostSettings.vue?vue&type=template&id=52f280e6&scoped=true"
import script from "./HostSettings.vue?vue&type=script&lang=js"
export * from "./HostSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f280e6",
  null
  
)

export default component.exports